import React from "react"
import { useTranslation } from "react-i18next"

export function MarkdownImage() {
  const { t } = useTranslation()
  return <span>{t("Markdown.ImageNotSupported")}</span>
}
